<template>
  <v-row class="ma-0 pa-0" :justify="justify" :align="align">
    <slot />
  </v-row>
</template>

<script>
export default {
  name: 'AppModalRow',

  props: {
    justify: {
      type: String,
      required: false,
    },
    align: {
      type: String,
      required: false,
    },
  }
}
</script>

<style>

</style>